<template>
	<v-row>
		<v-col>
			<ui-box>
				<h5>{{ customer.name }}</h5>
				<span class="grey--text text--darken-1 text-body-2">
				</span>

				<v-divider class="mb-10 mt-4 opacity-80"></v-divider>

				<v-row no-gutters>
					<v-col align-self="start" cols="4" md="12">
						<span class="font-weight-bold text-body-2 text-md-h6">Phone</span>
					</v-col>
					<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
						<a href="javascript:void(0)"
						   :title="'Click to call ' + customer.name"
						   @click="callPhone(customer.id, customer.phone)">{{
								customer.phone
							}}</a>
					</v-col>
				</v-row>
				<v-divider class="my-2"></v-divider>

				<v-row no-gutters>
					<v-col align-self="start" cols="4" md="12">
						<span class="font-weight-bold text-body-2 text-md-h6">email</span>
					</v-col>
					<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
						<a :href="'mailto:' + customer.email">{{
								customer.email
							}}</a>
					</v-col>
				</v-row>

				<v-row>
					<v-col>
						<customer-orders-table
							:partner="partner"
							:customer="customer"
							:extra-data="extraData"
							:orders="orders.active"
							title="Active Orders"
						></customer-orders-table>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<customer-orders-table
							:partner="partner"
							:customer="customer"
							:extra-data="extraData"
							:orders="orders.completedExpired"
							title="Completed/Expired Orders"
						></customer-orders-table>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<customer-orders-table
							:partner="partner"
							:customer="customer"
							:extra-data="extraData"
							:orders="orders.refundedCancelled"
							title="Refunded/Cancelled Orders"
						></customer-orders-table>
					</v-col>
				</v-row>

			</ui-box>
		</v-col>
	</v-row>
</template>

<script>

import {helpers} from '../../../helpers';
import CustomerOrdersTable from "./CustomerOrdersTable.vue";

export default {
	name: "ViewCustomer",
	components: {CustomerOrdersTable},
	props: {
		partner: {
			type: Object,
			default: () => ({})
		},
		customer: {
			type: Object,
			default: () => ({})
		},
		orders: {
			type: Object,
			default: () => ({})
		},
		extraData: {
			type: Object,
			default: () => ({})
		},
	},
	data() {
		return {}
	},
	methods: {
		callPhone(partnerUserId, phone) {
			helpers.callPhone(partnerUserId, phone);
		},
	}
};
</script>
